import { connect } from 'react-redux';
import { multiplePanelsOpen } from '../../../shared/actions/sidebarUtils';
import { closeAllPanels } from '../../../shared/actions/sidebar';
import ViewerOverlay from './viewerOverlay';

const mapDispatchToProps = dispatch => ({
  closeAllPanels: () => dispatch(closeAllPanels()),
});

const mapStateToProps = state => ({
  visible: multiplePanelsOpen(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewerOverlay);
